// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__0uZ5L","container":"footer_container__JihhA","nav":"footer_nav__K-RLy","links":"footer_links__gFy4A"};